export const OVERNIGHT_HOURS = 'Overnight Hours';
